import React, { useState, useEffect } from 'react';
import { PieChart, Pie, Tooltip, Legend, Cell, ResponsiveContainer } from 'recharts';
import styles from './style.module.css';
import Card from '../../Card';
import { formatToBRL } from 'brazilian-values';
import { getPieChartData } from '../../../services/kollectaApi';
import DateRangeSelector from '../DateRangeSelector';

const PieChartComponent = () => {
  const [renderChart, setRenderChart] = useState(false);
  const [dataChartCount, setDataChartCount] = useState(false);
  const [dataChart, setDataChart] = useState([]);
  const [startDate, setStartDate] = useState(new Date(Date.now() - 365 * 24 * 60 * 60 * 1000));
  const [endDate, setEndDate] = useState(new Date());
  const [activeIndex, setActiveIndex] = useState(null);
  const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1920);
  
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  // Ajustar tamanhos do gráfico baseado na largura da tela
  const isIntermediate = windowWidth <= 1680 && windowWidth >= 1440;
  const isSmallScreen = windowWidth < 1440;
  const isLargeScreen = windowWidth > 1680;
  const cx = isSmallScreen ? "40%" : isIntermediate ? "32%" : "35%";
  const innerRadius = isSmallScreen ? 80 : isIntermediate ? 35 : isLargeScreen ? 60 : 40;
  const outerRadius = isSmallScreen ? 180 : isIntermediate ? 85 : isLargeScreen ? 140 : 100;
  
  const getData = async () => {
    try {
      const data = { startDate, endDate };
      const response = await getPieChartData(data);
      setDataChart(response.data.data);
      setDataChartCount(response.data.count);
    } catch (error) {
      console.error('Failed to fetch pie chart data:', error);
    }
  };

  useEffect(() => {
    let timerId; 
    if (!renderChart) {
      timerId = setTimeout(() => setRenderChart(true), 1000); 
    }
    getData(); 

    return () => clearTimeout(timerId); 
  }, [startDate, endDate]);

  const CustomLegend = (props) => {
    const { payload, activeIndex } = props;
    return (
      <ul className={styles.legend}>
        {payload.map((entry, index) => (
          <li 
            key={`item-${index}`} 
            className={activeIndex === index ? styles.activeLegend : ''}
            style={{ margin: '4px 0' }}
          >
            <svg width="26" height="9" style={{ display: 'inline-block', marginRight: '4px' }}>
              <rect x="0" y="0" width="26" height="9" rx="4.5" ry="4.5" fill={COLORS[index]} />
            </svg>
            <span><b className={styles.piePercentage}>{entry?.payload?.payload?.percentage}%</b>  {entry?.payload?.payload?.status}</span>
          </li>
        ))}
      </ul>
    );
  };
 
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className={styles.tooltip}>
          <p className={styles.intro}>{`${formatToBRL(payload[0].value / 100)}`}</p>
        </div>
      );
    }
    return null;
  };
  
  const COLORS = ["#334588", "#00CED1", "#08B984", "#03B4DB", "#7300CF", "#FF9900", "#DF0000", "#FF5C00", "#8B0000", "#FFD700", "#828282"];

  const handleDateChange = async (dates) => {
    const { start, end } = dates;
    setStartDate(start);
    setEndDate(end);
    await getData();
  };

  const handleMouseEnter = (_, index) => {
    setActiveIndex(index);
  };

  const handleMouseLeave = () => {
    setActiveIndex(null);
  };

  return (
    <Card overflowVisible>
      <section className={styles.wrapper}>
        <div className={styles.topContent}>
          <h1>Segmentação da carteira</h1>
          <div> 
            <DateRangeSelector 
              onDateChange={handleDateChange} 
              startDate={startDate}
              endDate={endDate}
            /> 
          </div>
        </div>
        
        {renderChart && dataChart ? (
          dataChartCount > 0 ? (
            <div className={styles.chartContainer}>
              <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={dataChart}
                cx={cx}
                cy="50%"
                innerRadius={innerRadius}
                outerRadius={outerRadius} 
                fill="#8884d8"
                dataKey="amount"
                labelLine={true}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                {dataChart.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip content={<CustomTooltip />} offset={20} />
              <Legend
                content={<CustomLegend activeIndex={activeIndex} />}
                layout='vertical'
                align='right'
                verticalAlign='middle'
                wrapperStyle={{ fontSize: '12px' }}
              />
            </PieChart>
              </ResponsiveContainer>
            </div> 
          ) : (
            <p>Nenhum dado disponível para o período especificado. Altere o filtro de datas.</p>
          )
        ) : (
          <p>Carregando...</p>
        )}
      </section>
    </Card>
  )
}

export default PieChartComponent;
